<template>
  <table-list
      ref="list"
      :height="height"
      @query="handleLoadList"
      :back-top="false"
      :auto="false"
      :request-params="requestParams"
      :page-sizes="[5, 10]"
      :data="tableData" >
    <el-table-column align="center" :label="$t('编号')" prop="num" />
    <el-table-column align="center" :label="$t('图片')">
      <template v-slot="{row}">
        <preview-img :size="40" :img-url="row.photo" />
      </template>
    </el-table-column>
    <el-table-column align="center" :label="$t('分类')" prop="sortName" />

    <template v-for="(item, index) in columnList">
      <el-table-column :key="index" align="center" :label="$t(item.label)" :prop="item.prop" />
    </template>
    <slot></slot>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "RecipeRecordList",
  components: {PreviewImg, TableList},
  props: {
    columnList: {
      type: Array,
      default: () => []
    },
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.cookbook.listByType, params);
        this.tableData = res.cookbooks.map(item => {
          item.collectTimeStr = item.collectTime ? this.$moment(item.collectTime).format("YYYY-MM-DD HH:mm:ss") : null;
          item.useTimeStr = item.useTime ? this.$moment(item.useTime).format("YYYY-MM-DD HH:mm:ss") : null;
          item.evaluateTimeStr = item.evaluateTime ? this.$moment(item.evaluateTime).format("YYYY-MM-DD HH:mm:ss") : null;
          item.payTimeStr = item.payTime ? this.$moment(item.payTime).format("YYYY-MM-DD HH:mm:ss") : null;
          item.rewardTimeStr = item.rewardTime ? this.$moment(item.rewardTime).format("YYYY-MM-DD HH:mm:ss") : null;
          item.watchTimeStr = item.watchTime ? this.$moment(item.watchTime).format("YYYY-MM-DD HH:mm:ss") : null;
          item.star = item.star ? item.star.toFixed(2) : 0;
          return item;
        })
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  computed: {
   requestParams() {
     return {
       searchType: this.type,
       userNum: this.$route.query.num
     }
   }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
